import * as AlertDialog from '@givebutter/primitives/alert-dialog';

interface CancelAuctionProps {
    isOpen: boolean;
    onIsOpenChange: (open: boolean) => void;
    onClickCancelAuction: () => void;
}

const CancelAuction = ({ isOpen, onIsOpenChange, onClickCancelAuction }: CancelAuctionProps) => {
    return (
        <AlertDialog.Root type={'error'} open={isOpen} onOpenChange={onIsOpenChange}>
            <AlertDialog.Portal>
                <AlertDialog.Overlay />
                <AlertDialog.Content>
                    <AlertDialog.Header>
                        <AlertDialog.Icon />
                        <AlertDialog.Close />
                    </AlertDialog.Header>
                    <AlertDialog.Body>
                        <AlertDialog.Title>Cancel Auction?</AlertDialog.Title>
                        <AlertDialog.Description>
                            This action will cancel all active and upcoming items. Items that are
                            closed and have a winner will still require fulfillment.
                        </AlertDialog.Description>
                    </AlertDialog.Body>
                    <AlertDialog.Footer>
                        <AlertDialog.Cancel onClick={() => onIsOpenChange(false)}>
                            Cancel
                        </AlertDialog.Cancel>
                        <AlertDialog.Action onClick={() => onClickCancelAuction()}>
                            Cancel Auction
                        </AlertDialog.Action>
                    </AlertDialog.Footer>
                </AlertDialog.Content>
            </AlertDialog.Portal>
        </AlertDialog.Root>
    );
};

export { CancelAuction };
